import Vue from "vue";
import VueI18n from "vue-i18n";
import enLocale from "./en";
import esLocale from "./es";
import Cookies from "js-cookie";

Vue.use(VueI18n);

const messages = {
  en: enLocale,
  es: esLocale,
};

// console.log(Cookies.get("locale"));

const i18n = new VueI18n({
  // set locale
  // options: en | es
  locale: Cookies.get("locale") || "en",
  fallbackLocale: "en",
  // set locale messages
  messages,
});

Vue.prototype.locale = i18n;
export default i18n;
